import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { AlertCircle } from 'lucide-react';
import logger from '../../utils/logger';

/**
 * InactivityWarningModal Component
 *
 * Displays a warning modal when user is about to be logged out due to inactivity
 * Shows a countdown timer and allows user to extend their session
 *
 * @param {boolean} show - Whether modal is visible
 * @param {number} secondsRemaining - Number of seconds until auto-logout
 * @param {Function} onExtendSession - Callback when user clicks "Stay Logged In"
 */
const InactivityWarningModal = ({ show, secondsRemaining, onExtendSession }) => {
  const handleExtendSession = () => {
    logger.debug('User extended session due to inactivity warning');
    if (onExtendSession) {
      onExtendSession();
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleExtendSession}
      backdrop="static"
      keyboard={false}
      centered
      size="sm"
    >
      <Modal.Header className="border-0 pb-0">
        <Modal.Title className="d-flex align-items-center w-100">
          <AlertCircle className="text-warning me-2" size={24} />
          <span>Session Timeout Warning</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center pt-2">
        <p className="mb-3">
          You've been inactive for a while. You will be automatically logged out in:
        </p>
        <div className="mb-3">
          <h2 className="text-warning mb-0" style={{ fontSize: '2.5rem', fontWeight: 'bold' }}>
            {secondsRemaining}
          </h2>
          <small className="text-muted">second{secondsRemaining !== 1 ? 's' : ''}</small>
        </div>
        <p className="text-muted small mb-0">
          Click "Stay Logged In" to continue your session.
        </p>
      </Modal.Body>
      <Modal.Footer className="border-0 justify-content-center">
        <Button
          variant="primary"
          onClick={handleExtendSession}
          className="px-4"
        >
          Stay Logged In
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InactivityWarningModal;

